import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { Modal } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';
import ExpandCollapseText from '@/pages/intelligence/components/ExpandCollapse';

export default function TextMore(props) {
  const { data, title } = props;

  const multiRow = useRef(null);
  // const [needMore, setNeedMore] = useState(false);
  const [isShow, setShow] = useState(false);
  const { formatMessage } = useIntl();

  // useEffect(() => {
  //   const height = parseInt(multiRow?.current.offsetHeight);
  //   const lineHeight = 21;
  //   // console.log(height, lineHeight)
  //   if (height > lineHeight * 3) {
  //     setNeedMore(true);
  //   }
  // }, [data]);

  return (
    // <div className='dbi-table-multi'>
    //   <div className='dbi-table-multi-row'>
    //     <span
    //       ref={multiRow}
    //       dangerouslySetInnerHTML={{ __html: data }}
    //     />
    //   </div>
    //   { needMore ?
    //     <span className='dbi-table-multi-more'
    //       onClick={() => {
    //         setShow(!isShow);
    //       }}
    //     >
    //       More
    //     </span>
    //     :
    //     null
    //   }
    //   {/* 弹窗 */}
    //   <Modal
    //     // className='dbi-market-textactivities-modal'
    //     caption={title}
    //     visible={isShow}
    //     onClose={() => { setShow(!isShow) }}
    //   >
    //     <Modal.Body>
    //       <div
    //         dangerouslySetInnerHTML={{ __html: data }}
    //       />
    //     </Modal.Body>
    //   </Modal>
    // </div>
    <>
      <ExpandCollapseText
        text={data}
        rowNum={3}
        otherText={formatMessage({ id:'dbi_more' })}
        onClick={() => {
          setShow(!isShow);
        }}
      />
      <Modal
        className="dbi-more-modal"
        caption={title}
        visible={isShow}
        onClose={() => {
          setShow(!isShow);
        }}
      >
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: data }} />
        </Modal.Body>
      </Modal>
    </>
  );
}
